// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__blNCd","labels":"Breadcrumbs_labels__tnlRs"};